export function GetHelpIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M4.39,4.39a7.93,7.93,0,1,0,11.22,0A7.95,7.95,0,0,0,4.39,4.39Zm9.07.29L11.35,6.8a3.48,3.48,0,0,0-2.54-.06L6.67,4.6A6.36,6.36,0,0,1,13.46,4.68Zm-2.1,6.68a1.92,1.92,0,1,1,0-2.72A1.93,1.93,0,0,1,11.36,11.36ZM4.66,6.58,6.78,8.7a3.48,3.48,0,0,0,0,2.65L4.68,13.46A6.35,6.35,0,0,1,4.66,6.58Zm2.05,8.85,2.15-2.15a3.42,3.42,0,0,0,2.44-.06l2.12,2.12A6.36,6.36,0,0,1,6.71,15.43Zm8.69-2.1-2.14-2.14a3.45,3.45,0,0,0,0-2.33l2.15-2.15A6.36,6.36,0,0,1,15.4,13.33Z" />
    </svg>
  )
}
